import script from "./EventActivitiesCaroussel.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventActivitiesCaroussel.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__